export enum MeasureUnitType {
    ACRE = "ACRE",
    HECTARE = "HECTARE",
    CELCIUS = "CELCIUS",
    FAHRENHEIT = "FAHRENHEIT",
    MM = "MM",
    INCH = "INCH",
    METER = "METER",
    FOOT = "FOOT",
    METER_PER_SECOND = "METER_PER_SECOND",
    MILE_PER_HOUR = "MILE_PER_HOUR",
    KG_PER_HECTARE = "KG_PER_HECTARE",
    LB_PER_ACRE = "LB_PER_ACRE",
}
